var base = require('settings/teams/team-settings');

Vue.component('spark-team-settings', {
    mixins: [base]
});



// WEBPACK FOOTER //
// ./resources/js/spark-components/settings/teams/team-settings.js